<div class="org-wrapper" dir="ltr">
	<ng-container *ngIf="!viewOnly && !customOptions?.takeDecision?.enabled">
		<button type="button" class="btn-button btn-add" (click)="add(orgNodeConfig)"
			[disabled]="orgNodeConfig?.maxItem == orgData.length">
			{{'forms.common.Add' |translate}}</button>

		<br />
		<br />
	</ng-container>

	<div id="orgViewport">
		<p-organizationChart id="orgContent" [value]="orgData" selectionMode="single" styleClass="company">
			<ng-template let-node pTemplate="orgItem">
				<div (contextmenu)="onRightClick($event, node)" (click)="openProfile(node)">

					<img class="avatar {{node.data.node.invertImage ? 'grayscale': null}}"
						src="{{node.data.node.image || 'assets/images/user-logo.png'}}" />
					<div class="header {{cssDecisionClass(node)}}">
						{{'forms.common.' + node.data.dataItem.role | translate}}</div>
					<div class="content">
						<div>{{currentLang == 'ar' ? node.data.dataItem.arabicName :
							node.data.dataItem.englishName}}</div>

						<i class="fa fa-comment" *ngIf="hasRejectReason(node) as rejectKey"
							pTooltip="{{('forms.common.'+ rejectKey) | translate}}"
							(click)="$event.stopPropagation();showReason(node.data.dataItem,rejectKey)"></i>
					</div>
				</div>
			</ng-template>
		</p-organizationChart>

		<div style="visibility: hidden; position: fixed;" [style.left]="menuTopLeftPosition.x"
			[style.top]="menuTopLeftPosition.y" [matMenuTriggerFor]="rightMenu"></div>

		<mat-menu #rightMenu="matMenu" class="orgMenu">
			<ng-template matMenuContent let-actions="actions" let-currentNode="currentNode">
				<button *ngFor="let item of actions" mat-menu-item [disabled]="item.disable"
					[class.disable]="item.disable" (click)="orgItemClicked(item.key,currentNode)">
					{{ item.label}}
				</button>
			</ng-template>
		</mat-menu>

		<div class="info-hint" *ngIf="customOptions?.takeDecision?.enabled || hasDecision" [dir]="dir">
			<div>
				<span class="infoNoDecision"></span>
				{{'forms.common.NoDecision' | translate}}
			</div>
			<div>
				<span class="infoApprove"></span>
				{{'forms.common.Approve' | translate}}
			</div>
			<div>
				<span class="infoReject"></span>
				{{'forms.common.Reject' | translate}}
			</div>
		</div>
	</div>
</div>